__turbopack_context__.v({
  "list": "List-module__McZRIa__list",
});
